import { EntityLinks, ID, LinkedItemGoal, TaskLinkFields } from '@griply/types';

import { getDirectGoalLifeAreaIds } from './get-goal-life-area';
import { getGoalParentIds } from './goals/get-goal-parents';
import { taskGoalIds, taskLifeAreaIds } from './links/task-link-ids';

export type GetTaskLinkedItemIdsOptions = {
  links: EntityLinks;
};

// A goal may have several parents, so this walks a graph rather than a chain; `visited` keeps a
// diamond from being counted twice and a corrupt cycle from recursing forever.
const collectGoalAncestry = (
  goalId: ID | null,
  goalsById: Map<ID, LinkedItemGoal>,
  linkedItemIds: Set<ID>,
  visited: Set<ID>,
  links: EntityLinks,
): void => {
  if (!goalId || visited.has(goalId)) {
    return;
  }
  visited.add(goalId);

  const goal = goalsById.get(goalId);
  if (!goal) {
    return;
  }

  linkedItemIds.add(goal.id);
  getDirectGoalLifeAreaIds(goal, links).forEach((lifeAreaId) =>
    linkedItemIds.add(lifeAreaId),
  );

  getGoalParentIds(goal, { links }).forEach((parentId) =>
    collectGoalAncestry(parentId, goalsById, linkedItemIds, visited, links),
  );
};

export const getTaskLinkedItemIds = (
  task: TaskLinkFields,
  goalsById: Map<ID, LinkedItemGoal>,
  { links }: GetTaskLinkedItemIdsOptions,
): Set<ID> => {
  const linkedItemIds = new Set<ID>();

  taskLifeAreaIds(task).forEach((lifeAreaId) => linkedItemIds.add(lifeAreaId));

  taskGoalIds(task).forEach((goalId) =>
    collectGoalAncestry(goalId, goalsById, linkedItemIds, new Set(), links),
  );

  return linkedItemIds;
};
